import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogStopChargeStationView.propTypes = {
  item: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogStopChargeStationView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');
  const [operationalDate, setOperationalDate] = useState('');

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    let param = {
      reason,
      operationalDate: operationalDate
        ? Utils.formatDateTimeToString(operationalDate, 'YYYY-MM-DD')
        : null,
      status: ChargeConstants.ChargeStationStatus.STOPPED,
    };
    param = _.omitBy(param, (value) => _.isEmpty(value) || _.isNil(value));
    setLoading(true);
    const result = await ChargeHelper.API.requestUpdateChargeStation(item?.stationId, param);
    if (result && _.isBoolean(result)) {
      ToastHelper.showSuccess('Ngừng hoạt động trạm sạc thành công');
      if (onDone) {
        onDone();
      }
    } else {
      ToastHelper.showError(result || 'Ngừng hoạt động trạm sạc thất bại');
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center px-5 pt-6 gap-2">
        <div className="mb-4">
          <img src={AppResource.images.dialogIcons.dialogStopAgency} />
        </div>

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Ngừng hoạt động trạm sạc
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
          Bạn có chắc muốn ngừng hoạt động trạm sạc:{' '}
          <span
            className="cursor-pointer hover-opacity-60"
            style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}
            onClick={() => { }}
          >
            {item?.name}
          </span>{' '}
          không?
        </span>
      </div>

      <div className="row m-0 p-0 px-3 mt-4">
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Lý do')}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder="Nhập lý do"
              name="reason"
              value={reason}
              onChange={(value) => {
                setReason(value);
              }}
            />
          </div>
        </div>

        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Thời gian hoạt động trở lại')}
            <KTFormInput
              type={KTFormInputType.date}
              placeholder="Chọn thời gian"
              name="operationalDate"
              value={operationalDate}
              onChange={(value) => {
                setOperationalDate(value);
              }}
              minTime={moment().add(1, 'days').toISOString()}
            />
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildRedButton('Ngừng hoạt động', handleSubmit, null, false, loading)}
      </div>
    </div>
  );
}

export default DialogStopChargeStationView;
